// Payment Accounts Section - Payment account fields
import React from 'react';
import { View } from 'react-native';
import { FormSection, NumericFormField } from '@/components/common/admin/form';
import { IPaymentAccount } from '@/types/admin/organizations';

interface PaymentAccountsSectionProps {
  paymentAccounts: IPaymentAccount[];
  onPaymentAccountChange: (index: number, accountNumber: string) => void;
  disabled?: boolean;
}

export const PaymentAccountsSection: React.FC<PaymentAccountsSectionProps> = ({
  paymentAccounts,
  onPaymentAccountChange,
  disabled,
}) => {
  return (
    <FormSection title="Payment Accounts">
      {paymentAccounts.map((account, index) => (
        <NumericFormField
          key={account.name}
          label={account.description}
          value={account.accountNumber?.toString() || ''}
          onChangeText={(text) => onPaymentAccountChange(index, text)}
          placeholder="Optional"
          editable={!disabled}
        />
      ))}
    </FormSection>
  );
};

